'use client'
import {useTranslation} from "react-i18next";
import {Form, message} from "antd";
import classes from "@/app/[locale]/(auth)/login/page.module.scss";
import {login} from "@/app/actions/formActions";
import Input from "@/app/components/form-fields/input/Input";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import Link from "next/link";
import GoogleButton from "@/app/components/buttons/google-button/GoogleButton";
import {useAppContext} from "@/app/context/UserContext";
import {useRouter} from "next/navigation";
import {useEffect, useState} from "react";
import Image from "next/image";
import Logo from "@/app/assets/images/header/seekintro-logo.svg";

const Login = () => {
    const {t} = useTranslation();
    const {setUser, user, setNotifications, setMeetingNotificationsNumber} = useAppContext();
    const router = useRouter();
    const [messageApi, contextHolder] = message.useMessage();
    const [serverErrors, setServerErrors] = useState();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const error = (msg) => {
        messageApi.open({
            type: 'error', content: msg,
        });
    };

    const googleRedirect = () => {
        let url;
        fetch(`${process.env.NEXT_PUBLIC_API_URL}/login/google`)
            .then((response) => response.json())
            .then((data) => {
                url = data.url
                router.push(data.url)
            }).catch((error) => {
            router.push('/login')
        })
    }

    // useEffect(() => {
    //     if (user && !user.google_account_connected) {
    //         googleRedirect();
    //     }
    // }, [user, googleRedirect]);

    return (<>
        {contextHolder}
        <div className={classes.modalContent}>
            <div className={classes.gradient}>
            </div>
            <div className={classes.loginSection}>
                <Image className={classes.mobileLogo} src={Logo} alt={'logo'}/>
                <div className={classes.header}>
                    <h3>{t('login')}</h3>
                    <p>{t('getConnected')}</p>
                </div>

                <Form form={form}  onFinish={(values) => {
                    setLoading(true);
                    login(values).then((res) => {
                        setLoading(false);
                        if (res?.data) {
                            setUser({...res.data.user})
                            setNotifications(res.data.user.unread_messages_count);
                            setMeetingNotificationsNumber(res.data.user.unread_notifications_count);
                            router.push('/');
                        } else {
                            setServerErrors(res.message);
                        }
                    })
                        .catch((err) => {
                        console.log('error:', err);
                    });
                }}
                      onFinishFailed={(error) => {
                      }}>
                    <Form.Item
                        name={"email"}
                        className={classes.emailInput}
                        rules={[{
                            required: true, message: t('validation.emailRequired'),
                        }, {
                            type: "email", message: t('validation.emailFormat'),
                        }, {
                            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: t('validation.emailPatternFormat')
                        }, {
                            max: 320, message: t('validation.emailMaxLength'),
                        },]}
                    >
                        <Input
                            onChange={() => setServerErrors()}
                            placeholder={t('placeholders.email')}
                        />
                    </Form.Item>
                    <Form.Item
                        name={"password"}
                        className={classes.passwordInput}
                        rules={[{
                            required: true, message: t('validation.passwordRequired'),
                        }, {
                            min: 8, message: t('validation.passwordLength'),
                        }, {
                            max: 128, message: t('validation.passwordTooLong')
                        }, {
                            pattern: /(?=.*[A-Z])/, message: t('validation.passwordUppercase'),
                        }, {
                            pattern: /(?=.*\d)/, message: t('validation.passwordNumber'),
                        }, {
                            pattern: /(?=.*\W)/, message: t('validation.passwordSpecialChar'),
                        },]}
                        help={serverErrors ? serverErrors : undefined}
                    >
                        <Input
                            onChange={() => setServerErrors()}
                            type="password"
                            placeholder={t('placeholders.password')}
                        />
                    </Form.Item>
                    <div className={classes.forgotLinkWrapper}>
                        <Link href={'/forgot-password'}>{t('forgotPassword.forgotPassword')}</Link>
                    </div>
                    <RoundedButton type="primary"
                                   htmlType={'submit'}
                                   className={classes.loginBtn}
                                   loading={loading}
                    >
                        {t('login')}
                    </RoundedButton>
                    <p className={classes.signUpLink}><span>{t('notAMember')}?</span><Link
                        href={'/register'}> {t("signUpNow")}</Link></p>
                </Form>
                <div className={classes.container}>
                    <div className={classes.line}></div>
                    <div className={classes.text}>or</div>
                    <div className={classes.line}></div>
                </div>
                <div style={{marginBottom: '-50px'}}>
                   <GoogleButton className={classes.googleBtn}/>
                </div>
            </div>
        </div>
    </>)
}

export default Login;